import { render, staticRenderFns } from "./GetSlide.vue?vue&type=template&id=65054ccb&scoped=true"
import script from "./GetSlide.vue?vue&type=script&lang=js"
export * from "./GetSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65054ccb",
  null
  
)

export default component.exports